import { render, staticRenderFns } from "./pagination.vue?vue&type=template&id=c709f41e&scoped=true"
import script from "./pagination.vue?vue&type=script&lang=ts"
export * from "./pagination.vue?vue&type=script&lang=ts"
import style0 from "./pagination.vue?vue&type=style&index=0&id=c709f41e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c709f41e",
  null
  
)

export default component.exports